export default __webpack_public_path__ + "static/media/icon-medal-silver.5ce9e565.svg";